import { MutationTree, GetterTree } from "vuex";

const state: any = {
  modified_reason_list: []
};

const mutations: MutationTree<any> = {
  SAVE_MODIFIED_FAIL_REASON(state, res): void {
    if (!state.modified_reason_list.includes(res)) {
      state.modified_reason_list.push(res);
    }
  },
  CLEAR_MODIFIED_FAIL_REASON(state): void {
    state.modified_reason_list = [];
  }
};

const getters: GetterTree<any, any> = {
  modified_reason_list(state: any): void {
    return state.modified_reason_list;
  }
};

export default { namespaced: true, state, mutations, getters };
